module.exports = __webpack_public_path__ + "static/media/gh.a25f96eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gh.svg
// module id = 127
// module chunks = 0